import {Button, Descriptions, Form, InputNumber, Typography} from "antd";
import {useEffect, useState} from "react";
import {DebugCrawlState, DebugCrawlStatus, getCrawlStatus, launchDebugCrawl, SchemaStats} from "../../../api/crawler";
import "moment/locale/ru";

const {Title} = Typography;


const state2Text = {
    "wait": "Ожидает",
    "in_progress": "В процессе",
    "export": "Подготовка файла...",
    "error": "Ошибка",
    "finished": "Завершено",
    "unknown": "Неизвестно",
}

function delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function LaunchCrawlerTab({site_id}: { site_id: number }) {
    const initialValues = {
        duration_minutes: 1,
        max_pubs: 2,
        max_urls: 2,
    }

    const [taskID, setTaskID] = useState<string | null>(null)
    const [state, setState] = useState<DebugCrawlState | null>(null)

    useEffect(() => {
        (async () => {
            while (true) {
                if (!taskID) {
                    return
                }

                if (taskID) {
                    const newState = await getCrawlStatus(taskID)
                    setState(newState)

                    if (newState.status == DebugCrawlStatus.Finished || newState.status == DebugCrawlStatus.Error) {
                        return
                    }
                }

                await delay(1000)
            }
        })()
    }, [taskID])

    const getSchemaStats = (state: DebugCrawlState) => {
        const ret: { key: string; value: SchemaStats; }[] = []
        if (!state) {
            return []
        }

        state.items_count_by_schema.forEach((value, key) => {
            ret.push({
                key: key,
                value: value
            })
        })

        return ret
    }

    return <>
        <Title level={5}>Остановить если</Title>
        <Form
            layout="vertical"
            initialValues={initialValues}
            onFinish={(values) => {
                (async () => {
                    const id = await launchDebugCrawl(site_id, values.duration_minutes * 60, values.max_pubs, values.max_urls)
                    setTaskID(id)
                })()
            }}
        >
            <Form.Item name="duration_minutes" label="Прошло минут">
                <InputNumber min={1} max={30} size="middle" style={{width: '100%'}}/>
            </Form.Item>

            <Form.Item name="max_pubs" label="Найдено валидных публикаций">
                <InputNumber min={0} max={1000} size="middle" style={{width: '100%'}}/>
            </Form.Item>

            {/*<Form.Item name="max_urls" label="Обошли урлов">*/}
            {/*    <InputNumber min={0} max={1000} size="middle" style={{width: '100%'}}/>*/}
            {/*</Form.Item>*/}

            <Button type={"primary"} htmlType={"submit"}>Запустить тестовый обход</Button>
        </Form>
        <br/>
        {
            taskID && <Descriptions title="Статус обхода" column={1} size={"small"} bordered>
                <Descriptions.Item label="ID задачи">{taskID || ""}</Descriptions.Item>
                <Descriptions.Item label="Запущено">{state?.start_time.fromNow()}</Descriptions.Item>
                <Descriptions.Item label="Состояние">{state2Text[state?.status || "unknown"]}</Descriptions.Item>
                {state?.error && <Descriptions.Item label="Текст ошибки">{state?.error}</Descriptions.Item>}
                <Descriptions.Item label="Обработано урлов">{state?.processed_urls_count}</Descriptions.Item>

                {
                    state && getSchemaStats(state).map(({key, value}) => {
                        return <Descriptions.Item label={key}>+{value.valid_count} -{value.invalid_count}</Descriptions.Item>

                    })
                }

                {
                    state?.status == DebugCrawlStatus.Finished && taskID &&
                    <Descriptions.Item label="Файл"><a href={`/api/crawler/task/${taskID}/file`}>Скачать</a></Descriptions.Item>
                }
            </Descriptions>
        }
    </>
}